import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import { placeholderFor, isEntitled, ASK_LINE, ASK_EMAIL } from '../modules/index.js';

// Session 8 Part 4: an entitled nav item with nothing built behind it yet.
// A deep link to a locked item shows the same text as the rail popover.
export default function Placeholder() {
  const { pathname } = useLocation();
  const { entitlements, activeClient } = useAuth();
  const item = placeholderFor(pathname);
  if (!item) return <Navigate to="/" replace />;
  const entitled = isEntitled(item, entitlements);
  return (
    <>
      <h1>{item.label}</h1>
      {item.description && <p className="lede">{item.description}</p>}
      <div className="empty">
        {entitled ? (
          <>
            <h2>We're setting this up for you</h2>
            <p>{item.label} is part of {activeClient?.name ? `${activeClient.name}'s` : 'your'} plan. It appears here as soon as it's ready.</p>
          </>
        ) : (
          <>
            <h2>Not in your plan yet</h2>
            <p>{ASK_LINE} <a href={`mailto:${ASK_EMAIL}?subject=${encodeURIComponent(`Add ${item.label} to our plan`)}`}>Email {ASK_EMAIL}</a></p>
          </>
        )}
      </div>
    </>
  );
}
